
    <div class="card" *ngIf="entity">
      <!-- Card Header -->
      <div class="card-header bg-dark text-white">
        <div class="row align-items-center">
          <div class="col">
            <h5 class="mb-0">Notification Settings</h5>
          </div>
          <div class="col-2 text-right p-0">
            <toggle-widget [options]="expand_settings"></toggle-widget>
          </div>
        </div>
      </div>

      <!-- Card Body -->
      <div class="card-body" [ngClass]="{ 'd-none': !expand_settings.toggle }">
        <!-- Push Notifications -->
        <div class="row mb-3">
          <div class="col-3 font-weight-bold">Push Notifications</div>
          <div class="col">
            <label class="switch switch-3d switch-success">
              <input
                class="switch-input switch-primary"
                (change)="togglePush($event)"
                [(ngModel)]="entity.pushEnabled"
                type="checkbox"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
          <div class="col">
            <input
              type="text"
              class="form-control"
              (change)="notificationChange()"
              [(ngModel)]="entity.pushUserChannel"
              placeholder="Channel: Leave Blank for Default"
            />
          </div>
        </div>

        <!-- Email Alerts -->
        <div class="row mb-3">
          <div class="col-3 font-weight-bold">Email Alerts</div>
          <div class="col">
            <ng-container
              *ngIf="
                subscriptionTypeName === 'plus' ||
                  subscriptionTypeName === 'advanced' ||
                  subscriptionTypeName === 'trial' ||
                  subscriptionTypeName === 'sms' ||
                  subscriptionTypeName === 'enhanced';
                else notSubscribed
              "
            >
              <label class="switch switch-3d switch-success">
                <input
                  class="switch-input switch-primary"
                  (change)="toggleEmail($event)"
                  [(ngModel)]="entity.emailEnabled"
                  type="checkbox"
                />
                <span class="switch-slider"></span>
              </label>
            </ng-container>

            <ng-template #notSubscribed>
              <div>User Not Subscribed</div>
            </ng-template>
          </div>
          <div class="col">
            <input
              type="text"
              class="form-control"
              (change)="notificationChange()"
              [(ngModel)]="entity.emailUserChannel"
              placeholder="Channel: Leave Blank for Default"
            />
          </div>
        </div>

        <!-- SMS Alerts -->
        <div class="row mb-3">
          <div class="col-3 font-weight-bold">Text / SMS Alerts</div>
          <div class="col">
            <ng-container
              *ngIf="
                subscriptionTypeName === 'plus' ||
                  subscriptionTypeName === 'advanced' ||
                  subscriptionTypeName === 'trial' ||
                  subscriptionTypeName === 'sms';
                else notSubscribed
              "
            >
              <label class="switch switch-3d switch-success">
                <input
                  class="switch-input switch-primary"
                  (change)="toggleSms($event)"
                  [(ngModel)]="entity.smsEnabled"
                  type="checkbox"
                />
                <span class="switch-slider"></span>
              </label>
            </ng-container>

            <ng-template #notSubscribed>
              <div>User Not Subscribed</div>
            </ng-template>
          </div>
          <div class="col">
            <input
              type="text"
              class="form-control"
              (change)="notificationChange()"
              [(ngModel)]="entity.smsUserChannel"
              placeholder="Channel: Leave Blank for Default"
            />
          </div>
        </div>

        <hr class="my-3" />

        <!-- Critical Alerts -->
        <div class="row">
          <div class="col-3 font-weight-bold">Set As Critical Alert</div>
          <div class="col">
            <ng-container
              *ngIf="
                subscriptionTypeName === 'plus' ||
                  subscriptionTypeName === 'trial';
                else notSubscribed
              "
            >
              <label class="switch switch-3d switch-success">
                <input
                  class="switch-input switch-primary"
                  (change)="toggleCriticalAlerts($event)"
                  [(ngModel)]="entity.criticalEnabled"
                  type="checkbox"
                />
                <span class="switch-slider"></span>
              </label>
            </ng-container>
            <ng-template #notSubscribed>
              <div>User Not Subscribed</div>
            </ng-template>
          </div>
          <div class="col">
            <input
              type="text"
              class="form-control"
              (change)="notificationChange()"
              [(ngModel)]="entity.smsUserChannel"
              placeholder="Channel: Leave Blank for Default"
            />
          </div>
        </div>
        <div class="row p-3">
          <p class="text-left">
            Reserved for the most important alerts. Alerts set as critical will
            attempt to send with a more urgent priority or designation.
          </p>
        </div>

        <hr class="my-3" />

        <div class="row mb-3">
          <div class="col-4 font-weight-bold">Frequency Settings</div>

          <div class="d-flex mr-2">
            <label class="switch switch-3d switch-warning">
              <input
                class="switch-input switch-primary"
                (change)="toggleFrequency('hourly', $event)"
                [(ngModel)]="entity.onceHourlyEnabled"
                type="checkbox"
              />
              <span class="switch-slider"></span>
            </label>
            <span style="margin-top:4px;" class="ml-2">Hourly</span>
          </div>
          <div class="d-flex mr-2">
            <label class="switch switch-3d switch-warning">
              <input
                class="switch-input switch-primary"
                (change)="toggleFrequency('daily', $event)"
                [(ngModel)]="entity.onceDailyEnabled"
                type="checkbox"
              />
              <span class="switch-slider"></span>
            </label>
            <span style="margin-top:4px;" class="ml-2">Daily</span>
          </div>
        </div>
      </div>
    </div>
  